import { Subject } from "rxjs";

export class AlertActionManagement {

    constructor(){
        this.updateAction.subscribe(val=>{
//console.log()
            this.progress[val[0]]= val[1];
            this.actionManagement.next(this.procressProgress())
        })
    }

    progress = {
        chartprogress : false,
        detailprogress: false,
        overviewprogress:false,
        eventsprogress : false
    }

    procressProgress(){
        return this.progress.eventsprogress || this.progress.detailprogress || this.progress.overviewprogress || this.progress.chartprogress;
    }

    updateAction:Subject<any> = new Subject();

    actionManagement:Subject<boolean> = new Subject();
    
    resetProgress(){
        for(let action in this.progress){
            this.progress[action]= false;
        }
    }
}